import React from 'react';

export const useWindowSize = (threshold = 50) => {
	const [size, setSize] = React.useState({ width: window.innerWidth, height: window.innerHeight });

	React.useEffect(() => {
		const handleResize = () => {
			setSize(prevSize => {
				const newWidth = window.innerWidth;
				if (Math.abs(prevSize.width - newWidth) >= threshold) {
					return { width: newWidth, height: window.innerHeight };
				}
				return prevSize;
			});
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [threshold]);

	return size;
};
